<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div class="flex items-center">
      @if (user?.photo) {
        <img [src]="user.photo | photo:'/rs:fill:100:100:1/g:no/' | async"
             class="avatar dropdown-heading-avatar"
             [alt]="userInitials">
      } @else {
        <div class="dropdown-heading-avatar dropdown-heading-avatar--fallback">
          {{ userInitials }}
        </div>
      }
      <div class="dropdown-heading" title="{{user?.email || authService.currentUserValue?.email}}">
        {{ user?.firstname || authService.currentUserValue.firstname }} {{ user?.lastname || authService.currentUserValue?.lastname }}
      </div>
    </div>
    <div class="flex flex-row gap-3">
      <button mat-icon-button matTooltip="Změna hesla" matTooltipPosition="below" type="button" (click)="changePassword()">
        <mat-icon class="notifications-header-icon" svgIcon="mat:password"></mat-icon>
      </button>

      <button mat-icon-button matTooltip="Zobrazit 2FA QR kód" matTooltipPosition="below" type="button" (click)="open2FAQRCode()">
        <mat-icon class="notifications-header-icon" svgIcon="mat:key"></mat-icon>
      </button>
<!--      <button mat-icon-button matTooltip="Nastavení" matTooltipPosition="below" type="button">-->
<!--        <mat-icon class="notifications-header-icon" svgIcon="mat:settings"></mat-icon>-->
<!--      </button>-->
    </div>
  </div>

  <div class="dropdown-content">
    @for(item of items; track item.id) {
      <a (click)="close()"
         [routerLink]="item.route"
         class="notification flex items-center"
         matRipple>
        <mat-icon [svgIcon]="item.icon" [ngClass]="item.colorClass" class="notification-icon flex-none"></mat-icon>
        <div class="flex-auto">
          <div class="notification-label">{{ item.label }}</div>
          <div class="notification-description">{{ item.description }}</div>
        </div>
        <mat-icon class="notification-chevron flex-none" svgIcon="mat:chevron_right"></mat-icon>
      </a>
    }
  </div>

  <div class="dropdown-footer flex items-center justify-between">
    <a (click)="logout()" [routerLink]="['/login']" color="primary" mat-button>Odhlásit</a>
  </div>
</div>
